"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePromisedBulkAssertions = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const create_bulk_assertions_mutation_1 = require("../create-bulk-assertions.mutation");
const usePromisedBulkAssertions = ({ catalogId }) => {
    const [createBulkAssertions, { loading, error }] = (0, react_2.useMutation)(create_bulk_assertions_mutation_1.CREATE_BULK_ASSERTIONS);
    const addBulkAssertions = (0, react_1.useCallback)((assertions, expectedMatchedProductCount) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const { data, error: responseError } = yield createBulkAssertions({
            fetchPolicy: 'no-cache',
            variables: {
                batchAssertions: Object.assign({ catalogId, clientMutationId: '', batches: assertions }, (expectedMatchedProductCount !== undefined && { expectedMatchedProductCount })),
            },
        });
        if (responseError) {
            throw new Error(responseError.message);
        }
        const mutationError = (_a = data === null || data === void 0 ? void 0 : data.productBatchAssertions) === null || _a === void 0 ? void 0 : _a.error;
        if (mutationError) {
            throw new Error(mutationError);
        }
        return {
            selectedNodeTitle: (_d = (_c = (_b = assertions[0]) === null || _b === void 0 ? void 0 : _b.categories) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.category,
            productsCount: (_h = (_g = (_f = (_e = assertions[0]) === null || _e === void 0 ? void 0 : _e.filter) === null || _f === void 0 ? void 0 : _f.id) === null || _g === void 0 ? void 0 : _g.in) === null || _h === void 0 ? void 0 : _h.length,
        };
    }), [catalogId, createBulkAssertions]);
    return {
        loading,
        error,
        addBulkAssertions,
    };
};
exports.usePromisedBulkAssertions = usePromisedBulkAssertions;
